import { render, staticRenderFns } from "./ImageDialog.vue?vue&type=template&id=ad6e48a2&scoped=true"
import script from "./ImageDialog.vue?vue&type=script&lang=js"
export * from "./ImageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6e48a2",
  null
  
)

export default component.exports